import { CreateEventSeriesDocument } from '@/generated/graphql';
import { useMutation } from '@vue/apollo-composable';
import { Ref, toValue } from 'vue';
import { EventSeriesCreateSchemaType } from '../forms/schemas';

export function useEventSeriesCreate(data: Ref<EventSeriesCreateSchemaType>) {
    const createEventSeries = useMutation(CreateEventSeriesDocument);

    async function create() {
        const res = await createEventSeries.mutate({
            ...toValue(data),
        });
        const { id } = res?.data?.createEventSeries?.eventSeries ?? {};
        if (id) {
            return { id, errors: [] };
        }
        return { id: undefined, errors: res?.errors };
    }

    return {
        create,
    };
}
